import { Controller } from "@hotwired/stimulus"
import { showToast } from "../utils/toast"

export default class extends Controller {
  static values = {
    url: String,
    fieldName: String,
    confirmMessage: String
  }

  remove(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!confirm(this.confirmMessageValue)) {
      return
    }

    const formData = new FormData()
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

    formData.append(`trader[${this.fieldNameValue}]`, "true")
    
    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      },
      body: formData
    })
    .then(async response => {
      if (response.ok) {
        window.location.reload()
      } else {
        showToast("Failed to remove image. Please try again.", "alert")
      }
    })
    .catch(error => {
      console.error("An error occurred while removing the image:", error)
      showToast("An error occurred while removing the image. Please try again.", "alert")
    })
  }
}
